import { Button, Col, Form, InputNumber, Row } from "antd";
import Valor from "../../../../../../../Models/Financeiro/Faturamento/Imposto/Configuracao/Valor";
import { PlusOutlined } from "@ant-design/icons";
import { Formatacoes } from "../../../../../../../Utils/Formatacao";
import InputDate from "../../../../../../Base/Input/InputDate";

interface IValorFormProps {
    adicionar:(valorAdd:Valor) => void;
    adicionarDepois?: React.ReactNode
}
export default function ValorFormBasic({
    adicionar,
    adicionarDepois
}:IValorFormProps) {
    const [formulario] = Form.useForm<Valor>();
    function onClickValor (e:React.MouseEvent<HTMLElement, MouseEvent>) {
        e.preventDefault();
        e.stopPropagation();

        formulario.validateFields({ validateOnly : false })
            .then(e => {
                e.dataInicial = Formatacoes.paraData(e.dataInicial)!;
                adicionar(e);
            }).catch(ex => {
               
            });
    }

    return <Form<Valor>
        form={formulario}
        layout="vertical"
        autoComplete="off"
    >
        <Row gutter={8} wrap>
            <Col xs={10}>
                <Form.Item<Valor> 
                    rules={[
                        {
                            required : true
                        }
                    ]}
                    name={"dataInicial"}
                >
                    <InputDate />
                </Form.Item>
            </Col>
            <Col xs={10}>
                <Form.Item<Valor>
                    rules={[
                        {
                            required : true
                        }
                    ]}
                    name={"valor"}
                >
                    <InputNumber<number>
                        addonAfter={adicionarDepois}
                        style={{ width: "100%" }} 
                        min={0} 
                        precision={2}
                        controls={false} 
                        placeholder="Valor" 
                    />
                </Form.Item>
            </Col>
            <Col xs={4}>
                <Button 
                    type="primary" 
                    shape="circle" 
                    htmlType="submit" 
                    onClick={onClickValor} 
                    icon={<PlusOutlined />} 
                />
            </Col>
        </Row>
    </Form>
}